/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

type TSensorLocationCoordinates = {
  x: number
  y: number
}

interface ISensorLocation {
  locationKey: string
  name: string
  coordinates: TSensorLocationCoordinates
  sensors: string[]
  sensorLocationState: 'pending' | 'saved'
  hidden?: boolean
}

type TSensorLocations = {
  [key: string]: ISensorLocation
}

enum EAdasProgramSensorBomCheckboxTypes {
  SENSOR_LOCATIONS = 'Sensor Locations',
  CAMERAS = 'Cameras',
  RADARS = 'Radars',
  LIDARS = 'Lidars',
  ULTRASONIC = 'Ultrasonics',
}

const MapSensorTypeToLabel: any = {
  [EAdasProgramSensorBomCheckboxTypes.CAMERAS]: {
    sensorBomList: 'Camera',
  },
  [EAdasProgramSensorBomCheckboxTypes.RADARS]: {
    sensorBomList: 'Radar',
  },
  [EAdasProgramSensorBomCheckboxTypes.LIDARS]: {
    sensorBomList: 'Lidar',
  },
  [EAdasProgramSensorBomCheckboxTypes.ULTRASONIC]: {
    sensorBomList: 'Ultrasonic',
  },
}

// const SensorTypeColors = {
//   [ECheckboxData.CAMERAS]: '#4CAF50',
//   [ECheckboxData.RADARS]: '#2196F3',
// }

interface ISensor {
  id: string
  sensorId: string
  sensorType: EAdasProgramSensorBomCheckboxTypes
  sensorLocations: ISensorLocation[]
  notes: string
}

const VEHICLE_IMAGE_SIZE_MULTIPLIER = 1.2
const VEHICLE_IMAGE_SIZE = {
  width: 496 * VEHICLE_IMAGE_SIZE_MULTIPLIER,
  height: 276 * VEHICLE_IMAGE_SIZE_MULTIPLIER,
  transform:"rotate(-180deg)"
}

const CAdasProgramsRequests = {
  updateOrFetchArgosJamaTreeData: { // TODO: Consolidate tree updates into HttpTriggerAdasPrograms and add actionUrlParams here.
    getUrl: (action: string) => `/HttpTriggerJama?action=${action}`,
    actionUrlParams: {
      fetch: 'fetchTree',
      update: 'updateTree',
      getProjects: 'getProjects',
      loadJamaObjects: 'loadJamaObjects',
    }
  },
  createCoverageRequirementReportMetadata: {
    url: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=createCoverageRequirementReportMetadata',
  },
  createCoverageRequirementReportData: {
    url: '/orchestrators/DurableFunctionsAdasProgramsOrchestrator',
  },
  getReportsTable: {
    url: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=getReportsTable',
  },
  getIsUpdatingReports: {
    url: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=isUpdatingReports',
  },
  coverageRequirementsReportOrder: {
    url: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=coverageRequirementsReportOrder',
  },
  getReport: {
    url: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=getReport',
  },
  deleteReport: {
    url: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=deleteReport',
  },
  saveReportsTable: {
    url: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=saveReportsTable',
  },
  editCoverageRequirementReportData: {
    url: '/orchestrators/DurableFunctionsAdasProgramsOrchestrator',
  },
  fetchGeneralAdasProgramData: {
    url: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=fetchGeneralAdasProgramData',
  },
  updateReportSummary: {
    url: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=updateReportSummary',
  },
  updateReport: {
    url: '/orchestrators/DurableFunctionsAdasProgramsOrchestrator',
  },
  generateCombinedReport: {
    url: '/HttpTriggerAdasPrograms?page=coverageRequirements&requestType=generateCombinedReport',
  },
}

export type {
  ISensorLocation,
  TSensorLocations,
  ISensor,
}
export {
  VEHICLE_IMAGE_SIZE,
  EAdasProgramSensorBomCheckboxTypes,
  MapSensorTypeToLabel,
  CAdasProgramsRequests
}